<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<section class="main-content-wrapper">
  <div *ngIf="loanSummary">
    <div class="row m-0" *ngIf="CompletedPage && CompletedPage.length > 0">
      <div class="col-md-12 mb-1">
        <div class="container">
          <div style="position: relative">
            <mat-progress-bar mode="determinate" [value]="progress" class="style1"></mat-progress-bar>

            <span style="position: absolute; top: 0.5em" [ngStyle]="{ left: progress + '%' }"></span>
          </div>

          <div class="d-flex justify-content-end">
            <span class="completed_progress_bar">
              {{ progress }}% completed
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 col-md-12 mt-0">
      <div class="col-md-12 mb-1" [ngClass]="
          loanSummary.CloseDate != null
            ? 'alert alert-danger'
            : loanSummary.Loan_Acc_Type != 'Own Fund'
            ? 'alert alert-info'
            : 'alert alert-success'
        " style="background-color: #ecfaf8 !important;">
        <div style="
            display: flex;
            align-items: center;
            justify-content: end;
            gap: 0.625rem;
            margin-bottom: 0.625rem;
          ">
          <!-- <div style="
              display: flex;
              gap: 0.625rem;
              align-items: center;
              width: 5.9375rem;
              justify-content: space-evenly;
            ">
            <i class="fa fa-info-circle Inquiry-style" *ngIf="inquiryId && Processid == 1" aria-hidden="true"
              (click)="ViewInquiry()"></i>

            <i class="fa fa-inr Inquiry-style" *ngIf="PageModel?.CustomerInfo?.length > 0"
              (click)="OnFeeAdd(loanSummary.ProductId)" aria-hidden="true" style="padding: 0; font-size: 1.5em"></i>
          </div> -->

          <div>
            <i class="fas fa-comment-dots btn" aria-hidden="true" (click)="openChatModal()"
              style="padding: 0; font-size: 1.5em; color: #0c5460 !important">
            </i>
          </div>
        </div>

        <div class="grid-container formborder">
          <div class="grid-item" *ngIf="loanSummary.LoanNo">
            <span class="fs-12"><B>Loan No :</B> {{ loanSummary.LoanNo }}</span>
          </div>
          <div class="grid-item" *ngIf="loanSummary.LoanDate">
            <span class="fs-12"><B>Loan Date :</B> {{ loanSummary.LoanDate }}</span>
          </div>
          <div class="grid-item">
            <span class="fs-12"><B>Application No:</B> {{ loanSummary.ApplicationNo }}</span>
          </div>
          <div class="grid-item">
            <span class="fs-12">
              <B>Application Date :</B>
              {{ loanSummary.Application_Date }}
            </span>
          </div>
          <div class="grid-item">
            <span class="fs-12"><B>Branch :</B> {{ loanSummary.Branch }}</span>
          </div>

          <div class="grid-item" *ngIf="loanSummary.LoanAmount">
            <span class="fs-12"><B>Loan Amount :</B> {{ loanSummary.LoanAmount }}</span>
          </div>

          <div class="grid-item">
            <span class="fs-12"><B>Product :</B> {{ loanSummary.Product }}</span>
          </div>
          <div class="grid-item">
            <span class="fs-12"><B>Borrower :</B> {{ loanSummary.Customer }}</span>
          </div>
          <div class="grid-item">
            <span class="fs-12">
              <B>Tenure :</B>
              {{ loanSummary.Tenure > 0 ? loanSummary.Tenure : "" }} (
              {{ loanSummary.Tenure > 0 ? Tenure_Name : "" }})
            </span>
          </div>

          <div class="grid-item" *ngIf="loanSummary.ExpiryDate">
            <span class="fs-12"><B>Expiry Date :</B> {{ loanSummary.ExpiryDate }}</span>
          </div>
          <div class="grid-item" *ngIf="loanSummary.CloseDate">
            <span class="fs-12"><B>Close Date :</B> {{ loanSummary.CloseDate }}</span>
          </div>
          <div class="grid-item" *ngIf="loanSummary.Loan_Acc_Category">
            <span class="fs-12">
              <B>Loan A/C Category :</B>
              {{ loanSummary.Loan_Acc_Category }}
            </span>
          </div>
        </div>
        <div class="text-left mb-2 mt-2 lenderStatusReject" *ngIf="
            LenderStatus == 'Not Consider' &&
            (Processid == 20 || Processid == 2)
          ">
          Rejected Application By Lender {{ LenderRemark }}
        </div>
        <div class="text-right mb-2 mt-2 lenderStatusDone" *ngIf="
            LenderStatus == 'Completed' && (Processid == 20 || Processid == 2)
          ">
          Completed Application By Lender
          {{ loanSummary.Loan_Acc_Category }} Remark- {{ LenderRemark }}
        </div>
        <div class="text-right mb-2 mt-2 lenderStatusPending" *ngIf="
            LenderStatus == 'Pending' && (Processid == 20 || Processid == 2)
          ">
          Pending Application By Lender {{ loanSummary.Loan_Acc_Category }}
        </div>
        <div class="text-right mb-2" style="padding-top: 0.6875rem" *ngIf="
            Status != 'C' &&
            (Processid == 20 || Processid == 2)&&
            (Legal_Process.length > 0 || Valuation_Process.length > 0)
          ">
          <button type="button" (click)="OnProcessAssignment()" mat-raised-button
            class="btn font-size-12 button-btn mr-3">
            Legal/Valuation Process Assignment
          </button>
        </div>

        <div class="text-right mb-2" style="padding-top: 0.6875rem" *ngIf="
            Status != 'C' &&
            lenderCompletePage?.length == 0 &&
            ((Credit_Approval?.length == 0 &&
              Lender_Approval?.length > 0 &&
              Processid == 20) ||
              (Processid == 2 && Lender_Approval?.length > 0))
          ">
          <button type="button" (click)="OnLenderProcessAssignment()" mat-raised-button
            class="btn font-size-12 button-btn mr-3">
            Lender Process Assignment
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="row col-md-12 m-0 mt-2 justify-content-end" *ngIf="inquiryId && Processid==1">

        <button type="button" class="ml-4"
          style="background-color: #28a745; border-radius: 1.25rem; height: 1.6875rem; color: #ffffff; font-size: 0.75rem;  margin-right: 5.3125rem !important; margin-top: 0.25rem; "
          mat-raised-button color="primary" (click)="ViewInquiry()" [class.spinner]="loading">
          View Inquiry
        </button>
      </div>-->
  <mat-tab-group class="Loan_Layout" [selectedIndex]="currentTab" (selectedTabChange)="onTabChange($event)">
    <mat-tab [aria-label]="LabelLoan" *ngIf="
        LoanInfo &&
        LoanInfo[0].MM_Name == 'Loan Info' &&
        Processid != 16 &&
        Processid != 17
      ">
      <ng-template mat-tab-label><span>{{ LoanInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-loan-info-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="LoanInfo[0]" [isNew]="isNew" [ProductId]="ProductId" [Status]="Status"
          [ProcessName]="ProcessName" [InquiryId]="inquiryId"
          (action)="onChildAction($event)"></app-quickloan-loan-info-view>
      </ng-template>
    </mat-tab>

    <!--
  Processid != 16 &&
  Processid != 17 -->

    <mat-tab [disabled]="TabDisabled" *ngIf="CustomerInfo && CustomerInfo[0].MM_Name == 'Customer Info'"
      [aria-label]="LabelCustomer">
      <ng-template mat-tab-label><span>{{ CustomerInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-customer-detail-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="CustomerInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-customer-detail-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        AccountInfo &&
        AccountInfo[0].MM_Name == 'Account Info' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelAccount">
      <ng-template mat-tab-label><span>{{ AccountInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-account-info-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="AccountInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-account-info-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        CustomerRef &&
        CustomerRef[0].MM_Name == 'Customer Reference' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelCustomerRef">
      <ng-template mat-tab-label><span>{{ CustomerRef[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-customer-reference-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="CustomerRef[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-customer-reference-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        IncExpInfo &&
        IncExpInfo[0].MM_Name == 'Customer Income and expenditure' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelIncExp" [isNew]="isNew">
      <ng-template mat-tab-label><span>{{ IncExpInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-income-expenditure-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="IncExpInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-income-expenditure-view>
      </ng-template>
    </mat-tab>

    <mat-tab [aria-label]="LabelBusinessAnalysis" [disabled]="TabDisabled" *ngIf="
        BusinessAnalysis &&
        BusinessAnalysis[0].MM_Name == 'Bank Statement Analysis' &&
        Processid != 16 &&
        Processid != 17
      " [isNew]="isNew">
      <ng-template mat-tab-label><span>{{ BusinessAnalysis[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-bank-analysis-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="BusinessAnalysis[0]" [isNew]="isNew" [ProductId]="ProductId"
          [Status]="Status" [ProcessName]="ProcessName" [InquiryId]="inquiryId"
          (action)="onChildAction($event)"></app-quickloan-bank-analysis-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        PendingDocs &&
        PendingDocs[0].MM_Name == 'Pending Document' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelDocs">
      <ng-template mat-tab-label><span>{{ PendingDocs[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-documents-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="PendingDocs[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-documents-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        LoanKeyFactor &&
        LoanKeyFactor[0].MM_Name == 'Loan Key Factor' &&
        LoanKeyFactor != 16 &&
        LoanKeyFactor != 17
      " [aria-label]="LabelDocs">
      <ng-template mat-tab-label><span>{{ LoanKeyFactor[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-loan-key-factor-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="LoanKeyFactor[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-loan-key-factor-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        CRCInfo &&
        CRCInfo[0].MM_Name == 'CRC' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelCRC">
      <ng-template mat-tab-label><span>{{ CRCInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-crc-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit" [Processid]="Processid"
          [PageData]="CRCInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-crc-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        PDCInfo &&
        PDCInfo[0].MM_Name == 'PDC' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelPDC">
      <ng-template mat-tab-label><span>{{ PDCInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-bank-pdc-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit" [Processid]="Processid"
          [PageData]="PDCInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-bank-pdc-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        AssetsInfo &&
        AssetsInfo[0].MM_Name == 'Assets Detail' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelAssets">
      <ng-template mat-tab-label><span>{{ AssetsInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-assets-info-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="AssetsInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-assets-info-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        FamilyMemberInfo &&
        FamilyMemberInfo[0].MM_Name == 'Family Member' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelFamilyMem">
      <ng-template mat-tab-label><span>{{ FamilyMemberInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-family-member-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="FamilyMemberInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-family-member-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        FiQuestionsInfo &&
        FiQuestionsInfo[0].MM_Name == 'FI Questions' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelFIQues">
      <ng-template mat-tab-label><span>{{ FiQuestionsInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-fi-questions-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="FiQuestionsInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-fi-questions-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        TVRQestionsInfo &&
        TVRQestionsInfo[0].MM_Name == 'TVR Questions' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelTVRQues">
      <ng-template mat-tab-label><span>{{ TVRQestionsInfo[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-tvr-questions-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="TVRQestionsInfo[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-tvr-questions-view>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="TabDisabled" *ngIf="
        LegalProcess &&
        LegalProcess[0].MM_Name == 'Legal Process' &&
        Processid != 17
      " [aria-label]="LabelLegalProcess">
      <ng-template mat-tab-label><span>{{ LegalProcess[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-legal-process-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="LegalProcess[0]" [isNew]="isNew" [ProductId]="ProductId" [Status]="Status"
          [ProcessName]="ProcessName" [InquiryId]="inquiryId"
          (action)="onChildAction($event)"></app-quickloan-legal-process-view>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="TabDisabled" *ngIf="
        ValuationProcess &&
        ValuationProcess[0].MM_Name == 'Valuation Process' &&
        Processid != 16
      " [aria-label]="LabelValuationProcess">
      <ng-template mat-tab-label><span>{{ ValuationProcess[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-valuation-process-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="ValuationProcess[0]" [isNew]="isNew" [ProductId]="ProductId"
          [Status]="Status" [ProcessName]="ProcessName" [InquiryId]="inquiryId"
          (action)="onChildAction($event)"></app-quickloan-valuation-process-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        Insurance &&
        Insurance[0].MM_Name == 'Insurance' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelInsurance">
      <ng-template mat-tab-label><span>{{ Insurance[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-insurance-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="Insurance[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-insurance-view>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="TabDisabled" *ngIf="
        PersonalDiscussion &&
        PersonalDiscussion[0].MM_Name == 'Personal Discussion' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelPersonalDiscussion" label="LabelPersonalDiscussion">
      <ng-template mat-tab-label><span>Personal Discussion</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-pd-questions-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="PersonalDiscussion[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-pd-questions-view>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="TabDisabled" *ngIf="
        FOIR && FOIR[0].MM_Name == 'FOIR' && Processid != 16 && Processid != 17
      " [aria-label]="LabelFOIR" label="LabelFOIR">
      <ng-template mat-tab-label><span>FOIR</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-foir-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit" [Processid]="Processid"
          [PageData]="FOIR[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-foir-view>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="TabDisabled" *ngIf="
        FileChecking &&
        FileChecking[0].MM_Name == 'FileChecking' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelFileChecking" label="LabelFileChecking">
      <ng-template mat-tab-label><span>File Checking</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-FileChecking-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="FileChecking[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-FileChecking-view>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="TabDisabled" *ngIf="
        SanctionConditions &&
        SanctionConditions[0].MM_Name == 'Sanction Conditions' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelSanctionConditions">
      <ng-template mat-tab-label><span>{{ SanctionConditions[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-sanction-conditions-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="SanctionConditions[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-sanction-conditions-view>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="TabDisabled" *ngIf="
        DVDeductionConditions &&
        DVDeductionConditions[0].MM_Name == 'DV Deduction' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelDVDeductionConditions">
      <ng-template mat-tab-label><span>{{ DVDeductionConditions[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-dv-deduction-info-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="DVDeductionConditions[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-dv-deduction-info-view>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="TabDisabled" *ngIf="
        LenderConditions &&
        LenderConditions[0].MM_Name == 'Lender Conditions' &&
        Processid != 16 &&
        Processid != 17
      " [aria-label]="LabelLenderConditions">
      <ng-template mat-tab-label><span>{{ LenderConditions[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-lending-conditions-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="LenderConditions[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-lending-conditions-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        RMRecommendation &&
        RMRecommendation[0].MM_Name == 'RM Recommendation'
      " [aria-label]="LabelRMRecommendation">
      <ng-template mat-tab-label><span>{{ RMRecommendation[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-recommendation-rm-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="RMRecommendation[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-recommendation-rm-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        BMRecommendation &&
        BMRecommendation[0].MM_Name == 'BM Recommendation'
      " [aria-label]="LabelBMRecommendation">
      <ng-template mat-tab-label><span>{{ BMRecommendation[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-recommendation-bm-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="BMRecommendation[0]" [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-recommendation-bm-view>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="TabDisabled" *ngIf="
        CreditUnderWritingRecommendation &&
        CreditUnderWritingRecommendation[0].MM_Name == 'Recommendation Credit Underwriting'
      " [aria-label]="LabelCreditUnderWritingRecommendation">
      <ng-template mat-tab-label><span>{{ CreditUnderWritingRecommendation[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-recommendation-creditunderwriting-view [loanSummary]="loanSummary"
          [Revert_IsEdit]="Revert_IsEdit" [Processid]="Processid" [PageData]="CreditUnderWritingRecommendation[0]"
          [Status]="Status" [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-recommendation-creditunderwriting-view>
      </ng-template>
    </mat-tab>


    <mat-tab [disabled]="TabDisabled" *ngIf="
        CreditApprovalRecommendation &&
        CreditApprovalRecommendation[0].MM_Name == 'Recommendation Credit Approval'
      " [aria-label]="LabelCreditApprovalRecommendation">
      <ng-template mat-tab-label><span>{{ CreditApprovalRecommendation[0].MM_Short_Name }}</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-recommendation-creditapproval-view [loanSummary]="loanSummary" [Revert_IsEdit]="Revert_IsEdit"
          [Processid]="Processid" [PageData]="CreditApprovalRecommendation[0]" [Status]="Status"
          [ProcessName]="ProcessName"
          (action)="onChildAction($event)"></app-quickloan-recommendation-creditapproval-view>
      </ng-template>
    </mat-tab>
    <!--<mat-tab *ngIf="inquiryId && Processid == 1" tabindex="10" label="Lead">
    <ng-template mat-tab-label><span>Inquiry Info</span></ng-template>
    <ng-template matTabContent>
      <app-quickloan-deviation  [inquiryId]="inquiryId"  (action)="onChildAction($event)"></app-quickloan-deviation>
    </ng-template>
  </mat-tab>-->
    <mat-tab [disabled]="TabDisabled" *ngIf="Deviation" label="Deviation">
      <ng-template mat-tab-label><span>Deviation/Final Submit</span></ng-template>
      <ng-template matTabContent>
        <app-quickloan-deviation-view [loanSummary]="loanSummary" [Processid]="Processid" [Status]="Status"
          [ProcessName]="ProcessName" (action)="onChildAction($event)"></app-quickloan-deviation-view>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div class="row m-0 ">
    <div class="col-md-12">
      <hr />
    </div>
  </div>
  <form #sdf="ngForm" novalidate class="formborder m-3 p-3 bg-white rounded shadow-sm">
    <!-- Row 1: Query Details -->
    <div class="row m-0 align-items-end">
      <div class="col-md-4 mb-2">
        <span class="required-lable">Employee</span>
        <select name="SelectEmployeeId" id="SelectEmployeeId" #refSelectEmployeeId="ngModel"
          class="form-control input-text-css" [(ngModel)]="SelectEmployeeId" [disabled]="isQueryReplyMode"
          [attr.disabled]="isQueryReplyMode ? 'disabled' : null"
          [style.pointer-events]="isQueryReplyMode ? 'none' : 'auto'"
          [style.background-color]="isQueryReplyMode ? '#e9ecef' : ''" [ngClass]="{
          'is-invalid': sdf.submitted && refSelectEmployeeId.invalid && !isQueryReplyMode,
          'alert-warning':
            refSelectEmployeeId.invalid && !isQueryReplyMode &&
            (refSelectEmployeeId.dirty ||
              refSelectEmployeeId.touched ||
              refSelectEmployeeId.untouched)
        }" [required]="!isQueryReplyMode">
          <option value="" *ngIf="!isQueryReplyMode">Select Employee</option>
          <option *ngFor="let emp of EmployeeDropdown" [value]="emp.EmpId">
            {{ emp.EmpName }}
          </option>
        </select>
      </div>
      <div class="col-md-3 mb-2">
        <span class="required-lable">Priority</span>
        <select name="Priority" id="Priority" #refPriority="ngModel" class="form-control input-text-css"
          [(ngModel)]="Priority" [disabled]="isQueryReplyMode" [attr.disabled]="isQueryReplyMode ? 'disabled' : null"
          [style.pointer-events]="isQueryReplyMode ? 'none' : 'auto'"
          [style.background-color]="isQueryReplyMode ? '#e9ecef' : ''" [ngClass]="{
          'is-invalid': sdf.submitted && refPriority.invalid && !isQueryReplyMode,
          'alert-warning':
            refPriority.invalid && !isQueryReplyMode &&
            (refPriority.dirty ||
              refPriority.touched ||
              refPriority.untouched)
        }" [required]="!isQueryReplyMode">
          <option value="">Select Priority</option>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
        </select>
      </div>
      <div class="col-md-5 mb-2">
        <span class="required-lable">Remarks</span>
        <textarea rows="1" name="Remarks" id="Remark" [(ngModel)]="Remarks" #refRemark="ngModel" placeholder="Remarks"
          class="form-control input-text-css" style="resize: none; height: 31px;" [ngClass]="{
          'is-invalid': sdf.submitted && refRemark.invalid,
          'alert-warning':
            refRemark.invalid &&
            (refRemark.dirty ||
              refRemark.touched ||
              refRemark.untouched)
        }" required></textarea>
      </div>
    </div>

    <!-- Row 2: Attachment & Submit -->
    <div class="row m-0 mt-1 align-items-end">
      <div class="col-md-4 mb-2">
        <span class="lable">Doc Title</span>
        <input type="text" name="queryDocTitle" id="queryDocTitle" [(ngModel)]="queryDocTitle" placeholder="Doc Title"
          class="form-control input-text-css" />
      </div>
      <div class="col-md-5 mb-4">
        <span class="lable mb-1">Attachment</span>
        <div class="d-flex align-items-center">
          <input type="file" #queryFileInput style="display: none;" (change)="onFilePicked($event)" />
          <button type="button"
            class="btn btn-outline-secondary input-text-css text-truncate mr-1 flex-grow-1 d-flex align-items-center justify-content-center"
            (click)="queryFileInput.click()" [disabled]="uploadingFiles" style="height: 30px;  width: 50%;">
            <i class="fa fa-paperclip mr-1 text-primary"></i>
            <span class="text-truncate">{{ selectedQueryFileName ? selectedQueryFileName : 'Upload Doc' }}</span>
          </button>
          <button type="button" class="btn btn-primary input-text-css d-flex align-items-center justify-content-center"
            (click)="addQueryAttachment()" [disabled]="uploadingFiles" title="Add Document"
            style="height: 31px; min-width: 40px;">
            <i class="fa fa-plus" *ngIf="!uploadingFiles"></i>
            <i class="fa fa-spinner fa-spin" *ngIf="uploadingFiles"></i>
          </button>
        </div>
      </div>
      <div class="col-md-3 mb-2 text-right">
        <button type="button" class="btn_default w-100" mat-raised-button
          style="height: 31px; line-height: 31px; padding: 0;" (click)="Update_Internal_Query_Logs()"
          [disabled]="uploadingFiles">
          {{ isQueryReplyMode ? 'Reply' : 'Send' }}
        </button>
      </div>
    </div>

    <!-- Row 3: Attached Files Badges -->
    <div class="row m-0 mt-2" *ngIf="queryAttachments && queryAttachments.length > 0">
      <div class="col-12 d-flex flex-wrap align-items-center p-2 rounded"
        style="background-color: #f8f9fa; border: 1px dashed #dee2e6;">
        <span class="text-muted font-weight-bold mr-2" style="font-size: 12px;">Attached Files ({{
          queryAttachments.length }}):</span>
        <div *ngFor="let att of queryAttachments; let i = index"
          class="badge badge-white border shadow-sm d-inline-flex align-items-center p-2 mr-2 mb-1"
          style="font-size: 12px; font-weight: normal; background-color: #ffffff; border-radius: 6px;">
          <i class="fa fa-file-text-o text-primary mr-1"></i>
          <strong class="mr-1 text-dark">{{ att.Title }}:</strong>
          <span class="text-muted text-truncate mr-2" style="max-width: 160px;" [title]="att.DocName">{{ att.DocName
            }}</span>
          <i class="fa fa-times text-danger cursor-pointer ml-1" style="cursor: pointer;"
            (click)="removeQueryAttachment(i)" title="Remove file"></i>
        </div>
      </div>
    </div>
  </form>
  <ng-container *ngIf="ShowFinalTab">
    <!-- <form #sdf="ngForm" novalidate class="formborder">
      <div class="row m-0"></div>
      <div class="row m-0 col-md-12">
        <div *ngIf="Status != 'C'" [ngClass]="'col-md-3'">
          <span class="required-lable">Action</span>
          <select name="SelectStatus" id="SelectStatus" #refSelectStatus="ngModel" class="form-control input-text-css"
            [(ngModel)]="SelectStatus" required [ngClass]="{
              'is-invalid': sdf.submitted && refSelectStatus.invalid,
              'alert-warning':
                refSelectStatus.invalid &&
                (refSelectStatus.dirty ||
                  refSelectStatus.touched ||
                  refSelectStatus.untouched)
            }">
            <option value="">Select Action</option>
            <option value="Completed" *ngIf="
                Completed &&
                (Processid != 6 || (NextProcessId > 0 && Processid == 6))
              ">
              To Be Continued
            </option>
            <option value="Hold" *ngIf="Hold && Processid != 16 && Processid != 17 ">Hold</option>
            <option value="Reject" *ngIf="Rejected && Processid != 16 && Processid != 17">Reject</option>
          </select>
        </div>

        <div class="col-md-3" *ngIf="
            Status != 'C' &&
            Processid != 16 &&
            Processid != 17 &&
            Processid != 22 &&
            SelectStatus != 'Reject' &&
            NextProcessId > 0
          " [ngClass]="SendBack ? 'col-md-3' : 'col-md-3'">
          <span>Next Process Name</span>
          <input name="NextProcessName" id="NextProcessName" [(ngModel)]="NextProcessName" #refNextProcessName="ngModel"
            readonly placeholder="Next Process Name" class="form-control input-text-css" />
        </div>

        <div class="col-md-3" *ngIf="
            Status != 'C' &&
            Processid != 16 &&
            Processid != 17 &&
            Processid != 22 &&
            SelectStatus != 'Reject' &&
            NextProcessId > 0
          " [ngClass]="SendBack ? 'col-md-3' : 'col-md-3'">
          <span class="required-lable">Assigned Employee</span>
          <select name="SelectAssignEmp" id="SelectAssignEmp" #refSelectAssignEmp="ngModel"
            class="form-control input-text-css" [disabled]="
              !(Processid == 10) &&
              (Status == 'R' || (Status == 'P' && !Mannual_Assignment))
            " [(ngModel)]="SelectAssignEmp" (ngModelChange)="onAssignEmpChange($event)" required [ngClass]="{
              'is-invalid': sdf.submitted && refSelectAssignEmp.invalid,
              'alert-warning':
                refSelectAssignEmp.invalid &&
                (refSelectAssignEmp.dirty ||
                  refSelectAssignEmp.touched ||
                  refSelectAssignEmp.untouched)
            }">
            <option value="">Select Assign Employee</option>
            <option *ngFor="let row of AsignEmpData" [value]="row.EmpId">
              {{ row.EmpName }}
            </option>
          </select>
        </div>

        <!-- *ngIf="Status != 'R' && Status != 'C' && SelectStatus == 'Completed'" -->
    <!-- <div [ngClass]="'col-md-3'" *ngIf="NextProcessId > 0">
          <span>Score</span>
          <select name="Score" id="Score" #refScore="ngModel" class="form-control input-text-css" [(ngModel)]="Score"
            required [ngClass]="{
              'is-invalid': sdf.submitted && refScore.invalid,
              'alert-warning':
                refScore.invalid &&
                (refScore.dirty || refScore.touched || refScore.untouched)
            }">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
        </div> -->

    <!-- <div [ngClass]="
            Processid > 1 && Status != 'R' && Status != 'C'
              ? 'col-md-9'
              : 'col-md-9'
          " *ngIf="Status != 'C'">
          <span>Remarks</span>
          <textarea rows="1" name="Remarks" id="Remark" [(ngModel)]="Remarks" #refRemark="ngModel" placeholder="Remarks"
            class="form-control input-text-css"></textarea>
        </div>
        <div class="col-md-6 mt-3 d-flex justify-content-start align-items-center" style="gap: 0.5rem"
          *ngIf="(Processid == 6) || (Status != 'C' && FinalSubmit) || (Status == 'C' && Processid==1)">
      
          <button type="button" class="btn font-size-12 button-btn" style="background-color: #0e2e2e; font-weight: 900"
            (click)="QuickLoanFinalSubmit()" *ngIf="Status != 'C' && FinalSubmit"
            [disabled]="Status == 'C' || !sdf.form.valid">
            Final Submit
          </button>
        </div>

        <div class="col-md-3 mt-3"
          *ngIf="(Processid !=16 && Processid!=17)&&(Processid > 1 && Status != 'C' && SendBack) && RevertedCount<=1">
          <button type="button" class="mt-2 btn font-size-12 button-btn" (click)="OnClickSendBack()">
            Send Back To Process
          </button>
        </div> 
      </div>
    </form> -->
  </ng-container>
</section>






<div class="modal fade in" id="FeeCheckModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Fee Charges
        </h6>
        <button type="button" (click)="OnCloseFeeCheckModel()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <form #ddf="ngForm" novalidate>
        <div class="modal-body">
          <div class="row m-0 col-md-12 mt-0">
            <div class="table-responsive">
              <mat-table [dataSource]="datasourceFeeCheck">
                <ng-container matColumnDef="HeadId">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>
                    #
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-height: 0.3125rem">
                    {{ i + 1 }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Charges_Name">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Charges Name</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    {{ row.Charges_Name }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Due">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Due</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    {{ row.Due }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Received">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Received</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    {{ row.Received }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="balance">
                  <mat-header-cell class="grid-header" *matHeaderCellDef>Balance</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">
                    {{ row.balance }}
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedFeeColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedFeeColumns"></mat-row>
              </mat-table>
            </div>
          </div>
          <div style="color: red">
            ** Above Charges Collection is Pending. Please Collect Amount Before
            Final Submit.
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" (click)="OnCloseFeeCheckModel()" class="btn font-size-12 button-btn"
            data-dismiss="modal">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade in" id="LenderProcessAssignmentModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Lender Assign
        </h6>
        <button type="button" (click)="OnCloseLenderProcessAssignmentModel()" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <form #df12="ngForm" novalidate>
        <div class="modal-body">
          <div class="row m-0 mb-1" *ngIf="Lender_Approval?.length > 0">
            <div class="col-md-6 p-1">Accounting Category</div>
            <div class="col-md-5 p-1">
              <select name="Loan_AccountingCategoryId" id="Loan_AccountingCategoryId"
                #refLoan_AccountingCategoryId="ngModel" required [(ngModel)]="Loan_AccountingCategoryId"
                class="form-control input-text-css" (change)="getAsignLenderEmpList()" [ngClass]="{
                  'is-invalid':
                    df12.submitted && refLoan_AccountingCategoryId.invalid,
                  'alert-warning':
                    refLoan_AccountingCategoryId.invalid &&
                    (refLoan_AccountingCategoryId.dirty ||
                      refLoan_AccountingCategoryId.touched ||
                      refLoan_AccountingCategoryId.untouched)
                }">
                <option value="">Select Accounting Category</option>
                <option *ngFor="let AccountingCat of AccountingCatDropdown" [value]="AccountingCat.Loan_CategoryId">
                  {{ AccountingCat.Loan_category }}
                </option>
              </select>
            </div>

            <div class="col-md-6 p-1">Lender Assignment</div>
            <div class="col-md-5 p-1">
              <select name="AssignBy" id="AssignBy" #refAssignBy="ngModel" required [ngClass]="{
                  'is-invalid': df12.submitted && refLAssignBy.invalid,
                  'alert-warning':
                    refAssignBy.invalid &&
                    (refAssignBy.dirty ||
                      refAssignBy.touched ||
                      refAssignBy.untouched)
                }" [(ngModel)]="LenderAssignBy" class="form-control input-text-css">
                <option value="">Select Assign By</option>
                <option *ngFor="let collection of AsignEmpDataLender" [value]="collection.EmpId">
                  {{ collection.EmpName }}
                </option>
              </select>
              <!--<textarea rows="2" name="Remark{{i}}" id="Remark{{i}}" [(ngModel)]="Process.Remark" #refRemark="ngModel"
              placeholder="Remark" class="form-control input-text-css" rows="1" [required]="Process.IsSelected == true"
              [ngClass]="{'is-invalid': ddf.submitted && refRemark.invalid, 'alert-warning': refRemark.invalid && (refRemark.dirty || refRemark.touched || refRemark.untouched)}"></textarea>-->
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" (click)="OnCloseLenderProcessAssignmentModel()" class="btn font-size-12 button-btn mr-2"
            data-dismiss="modal">
            Cancel
          </button>
          <button type="button" (click)="OnSaveLenderProcessAssignment()" class="btn font-size-12 button-btn"
            [disabled]="!df12.form.valid">
            Assign
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade in" id="chatModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">Internal Query Logs</h6>
        <button type="button" (click)="onCloseChatModel()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-md-12">
          <div class="table-responsive mt-1" style="border: none !important;">
            <mat-table [dataSource]="dataSourceChat" style="max-height: 25rem; width: 100%; overflow: auto; ">
              <ng-container matColumnDef="Id">
                <mat-header-cell class="grid-header mw50" *matHeaderCellDef>#</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw50">{{ i + 1 }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="From_EmpName">
                <mat-header-cell class="grid-header" *matHeaderCellDef>From Employee</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.From_EmpName }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="To_EmpName">
                <mat-header-cell class="grid-header" *matHeaderCellDef>To Employee</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.To_EmpName }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="From_Remark">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Query Remark</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  <div style="text-align: justify; word-break: break-word;">
                    {{ row.From_Remark }}
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="To_Remark">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Reply Remark</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  <div style="text-align: justify; word-break: break-word;">
                    {{ row.To_Remark || '-' }}
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Priority">
                <mat-header-cell class="grid-header" *matHeaderCellDef> Priority </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  <span *ngIf="row.Priority === 'High'" class="priority-badge high">High</span>
                  <span *ngIf="row.Priority === 'Medium'" class="priority-badge medium">Medium</span>
                  <span *ngIf="row.Priority === 'Low'" class="priority-badge low">Low</span>
                  <span
                    *ngIf="!row.Priority || (row.Priority !== 'High' && row.Priority !== 'Medium' && row.Priority !== 'Low')">
                    {{ row.Priority || '-' }}
                  </span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Status">
                <mat-header-cell class="grid-header" *matHeaderCellDef> Status </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  <span *ngIf="row.Status === 'Pending' || row.Status === 'P'" class="status-badge pending">
                    <span class="status-dot"></span>Pending
                  </span>
                  <span *ngIf="row.Status === 'Replied' || row.Status === 'R' || row.Status === 'Completed'"
                    class="status-badge replied">
                    <span class="status-dot"></span>Replied
                  </span>
                  <span
                    *ngIf="row.Status !== 'Pending' && row.Status !== 'P' && row.Status !== 'Replied' && row.Status !== 'R' && row.Status !== 'Completed'"
                    class="status-badge default">{{ row.Status }}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Send_On">
                <mat-header-cell class="grid-header" *matHeaderCellDef> Created Date </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.Send_On || row.SendOn || row.CreatedDate }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Reply_On">
                <mat-header-cell class="grid-header" *matHeaderCellDef> Reply Date </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.Reply_On || row.ReplyOn || row.To_Date || '-' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Docs">
                <mat-header-cell class="grid-header text-center" *matHeaderCellDef> Docs </mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell text-center">
                  <button *ngIf="hasChatDocs(row.Id)" type="button" class="docs-btn" (click)="openChatDocsModal(row)"
                    title="View Documents">
                    <i class="fa fa-eye"></i>
                    <span class="docs-count">{{ getDocsForChatQuery(row.Id).length }}</span>
                  </button>
                  <span *ngIf="!hasChatDocs(row.Id)" class="text-muted">-</span>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedTableColumns; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedTableColumns"></mat-row>
            </mat-table>
          </div>
          <div style="display: flex; align-items: center; justify-content: flex-end;">
            <button class="mt-2 btn font-size-12 button-btn ml-3" (click)="exportChatExcel()">
              <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
              Export
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Chat Query Documents Modal -->
<div class="modal fade in" id="chatDocsModal" tabindex="-1" role="dialog" aria-labelledby="chatDocsModalLabel"
  aria-hidden="true" data-backdrop="false" style="background-color: rgba(15, 23, 42, 0.55); z-index: 1060;">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content border-0 shadow-lg docs-modal">
      <div class="modal-header docs-modal-header align-items-center">
        <h6 class="modal-title font-weight-bold mb-0 text-white" id="chatDocsModalLabel">
          <i class="fa fa-file-text-o mr-2"></i> Query Documents
          <span class="app-no-chip">{{ selectedQueryRow?.Application_No || loanSummary?.ApplicationNo || '-' }}</span>
        </h6>
        <button type="button" class="close text-white" (click)="closeChatDocsModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <div class="table-responsive" *ngIf="selectedQueryDocs && selectedQueryDocs.length > 0">
          <table class="table table-hover mb-0 docs-table">
            <thead>
              <tr>
                <th style="width: 50px;">#</th>
                <th>Type</th>
                <th>Doc Title</th>
                <th>Doc Path / Name</th>
                <th>Created On</th>
                <th class="text-center" style="width: 90px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let doc of selectedQueryDocs; let i = index">
                <td>{{ i + 1 }}</td>
                <td>
                  <span class="comm-type-badge"
                    [ngClass]="(doc.Communication_Type === 'Reply' || doc.CommunicationType === 'Reply') ? 'reply' : 'request'">
                    {{ doc.Communication_Type || doc.CommunicationType || 'Request' }}
                  </span>
                </td>
                <td class="font-weight-bold">{{ doc.Doc_Title || '-' }}</td>
                <td class="text-truncate" style="max-width: 220px;" [title]="doc.Doc_Path">{{ doc.Doc_Path || '-' }}
                </td>
                <td>{{ doc.CreatedOn || '-' }}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm button-btn p-1 px-2" (click)="viewChatDocument(doc)"
                    title="Open in new tab">
                    <i class="fa fa-eye mr-1"></i> View
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!selectedQueryDocs || selectedQueryDocs.length === 0" class="text-center py-4 text-muted">
          <i class="fa fa-folder-open-o fa-2x mb-2"></i>
          <p class="mb-0">No documents found for this query.</p>
        </div>
      </div>
      <div class="modal-footer p-2 px-3">
        <button type="button" class="btn btn-secondary btn-sm" (click)="closeChatDocsModal()">Close</button>
      </div>
    </div>
  </div>
</div>

<div style="display: none;">
  <table id="export-chat" class="table table-bordered bg-white"
    style="font-family: 'Times New Roman', Times, serif; display: none">
    <thead>
      <tr>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">#</th>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">From
          Employee
        </th>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">To Employee
        </th>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">Query
          Remark
        </th>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">Reply
          Remark
        </th>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">Priority
        </th>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">Status</th>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">Created
          Date
        </th>
        <th style="background-color: #08415c; color: #ffffff; font-weight: bold; border: 1px solid #cbd5e1;">Reply Date
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of (dataSourceChat?.data || JsonData || []); let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ item.From_EmpName }}</td>
        <td>{{ item.To_EmpName }}</td>
        <td>{{ item.From_Remark }}</td>
        <td>{{ item.To_Remark || item.ToRemark || '-' }}</td>
        <td>{{ item.Priority || '-' }}</td>
        <td>{{ item.Status }}</td>
        <td>{{ item.Send_On || item.SendOn || item.CreatedDate }}</td>
        <td>{{ item.Reply_On || item.ReplyOn || item.To_Date || '-' }}</td>
      </tr>
    </tbody>
  </table>
</div>